import { z } from 'zod';
import { PositiveIntSchema } from './common.schemas';
export * from '../user-listing.types';
import type {
    PublicUserListingSearchRequest,
    UserListingSearchRequest,
} from '../user-listing.types';
import { AuthorizationOpaqueCursorQuerySchema } from './authorization.schemas';
import { SearchTermsSchema } from './omnisearch.schemas';

export const USER_LISTING_MAX_PAGE_LIMIT: number = 1000;

export const UserListingPaginationLimitQuerySchema: z.ZodType<number | undefined> = z.coerce
    .number()
    .int()
    .positive()
    .optional()
    .transform((value: number | undefined) => {
        if (value === undefined) {
            return undefined;
        }
        return Math.min(value, USER_LISTING_MAX_PAGE_LIMIT);
    });

export const UserListingPaginationCursorQuerySchema: z.ZodType<number | undefined> =
    PositiveIntSchema.optional();

export const UserListingShowDeletedQuerySchema: z.ZodType<boolean | undefined> = z
    .union([z.boolean(), z.enum(['true', 'false'])])
    .transform((value: boolean | 'true' | 'false') => value === true || value === 'true')
    .optional();

export const UserListingSearchRequestSchema: z.ZodType<UserListingSearchRequest> = z
    .object({
        terms: SearchTermsSchema,
        limit: UserListingPaginationLimitQuerySchema,
        cursor: UserListingPaginationCursorQuerySchema,
        show_deleted: UserListingShowDeletedQuerySchema,
    })
    .strict();

export const PublicUserListingSearchRequestSchema: z.ZodType<PublicUserListingSearchRequest> = z
    .object({
        terms: SearchTermsSchema,
        limit: UserListingPaginationLimitQuerySchema,
        cursor: AuthorizationOpaqueCursorQuerySchema,
        show_deleted: UserListingShowDeletedQuerySchema,
    })
    .strict();
